import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getElementStatsByIdentifier } from "core-integration/src/store/element-stats/reducers";
import { IElementStat } from "core-integration/src/store/element-stats/types";
import { getElement } from "core-integration/src/store/elements/reducers";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import { IFixtureAllStat } from "core-integration/src/store/fixtures/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { useDispatch, useSelector } from "react-redux";
import { visuallyHidden } from "../../../../../styles/utils.css";
import { getElementStatNames } from "../../../../../utils/elementStats";
import ElementDialogButton from "../../../../ElementDialogButton";
import ElementInTable from "../../../../ElementInTable";
import {
  playerCellStyles,
  playerRowStyles,
  statsCellStyles,
} from "./playerStatsTable.css";

interface PlayerStatsRowProps {
  stat: IFixtureAllStat;
}

const PlayerStatsRow = ({ stat }: PlayerStatsRowProps) => {
  const dispatch = useDispatch<ThunkDispatch>();

  const teamsById = useSelector(getTeamsById);
  const element = useSelector((state: RootState) =>
    getElement(state, stat.element),
  );

  const statsByName: Record<string, IElementStat> = useSelector(
    getElementStatsByIdentifier,
  );
  const statNames = getElementStatNames();

  return (
    <tr className={playerRowStyles}>
      <td>
        <ElementDialogButton elementId={element.id} variant="list" />
      </td>
      <th scope="row" className={playerCellStyles}>
        <span className={visuallyHidden}>
          {element.web_name}, {teamsById[element.team].name}
        </span>
        <ElementInTable
          actionMe={() => dispatch(showElementSummary(element.id))}
          element={element}
          team={teamsById[element.team]}
          renderDreamTeam={element.in_dreamteam}
        />
      </th>
      <td className={statsCellStyles}>{stat.total_points}</td>
      {statNames.map((n) => (
        <td key={n} className={statsCellStyles}>
          {stat[statsByName[n].name]}
        </td>
      ))}
    </tr>
  );
};
export default PlayerStatsRow;
